import {PropsWithChildren, ReactNode} from "react";
import {Box, BoxProps, Sheet} from "@mui/joy";
import {mergeSx} from "../components/joyx.tsx";

export interface PageShellProps {
    header: ReactNode;
    body: ReactNode;
}

const pageHeaderSx = {
    gridArea: "header",
    zIndex: 10,
    position: "sticky",
    top: 0,
} as const;

const pageBodySx = {
    gridArea: "body",
    zIndex: 5,
} as const;

export function PageHeader({children, sx: inSx, ...rest}: PropsWithChildren<BoxProps>) {
    const sx = mergeSx(pageHeaderSx, inSx);
    return <Box sx={sx} {...rest}>
        {children}
    </Box>
}

export function PageBody({children, sx: inSx, ...rest}: PropsWithChildren<BoxProps>) {
    const sx = mergeSx(pageBodySx, inSx);
    return <Box sx={sx} {...rest}>
        {children}
    </Box>
}

export function PageShell({children}: PropsWithChildren) {
    return <Sheet sx={{
        display: "grid",
        gridTemplateRows: "min-content 1fr",
        gridTemplateColumns: "auto",
        gridTemplateAreas: `"${pageHeaderSx.gridArea}" "${pageBodySx.gridArea}"`,
    }}>
        <Box id="expander" sx={{
            height: "100vh", gridColumn: "1 / -1", gridRow: "1 / span 2"
        }}/>
        {children}
    </Sheet>
}

